module.exports = __webpack_public_path__ + "static/media/android-badge@2x.19a94341.png";